<cap-list-loader [listLoader]="listLoader" [showTotal]="showTotal" [showZeilenSelect]="showZeilenSelect">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>
<ng-template #tableHeaders>
  <tr>
    <th>
      <cap-column-header [columnName]="'EGID'" [sortModel]="tableSortModel.columns.get('EGID')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'VersicherungsNummerAbkürzung'" [sortModel]="tableSortModel.columns.get('versicherungsNummer')">
      </cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Status'" [sortModel]="tableSortModel.columns.get('gebaeudeStatus')"></cap-column-header>
    </th>
    <th>
      {{ "Grundstuecke" | translate }}
    </th>
    <th>
      {{ "GebäudeeingangsadresseAdressen" | translate }}
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    <tr>
      @if (hasExternalGwrLink()) {
        <td>
          <a
            (click)="openExternalGWRLink(item.egid)"
            [ngbTooltip]="'DetailsZuGebaeudeWohnungsregister' | translate"
            container="body"
            style="cursor: pointer">
            {{ item.egid }}
          </a>
        </td>
      }
      @if (!hasExternalGwrLink()) {
        <td>{{ item.egid }}</td>
      }
      <td>
        <cap-link [params]="[item.egid]" [target]="navTargets.NAV_GWR_GEBAUEDE" [tooltipParams]="{ nummer: item.egid }">
          {{ item.versicherungsNummer }}
        </cap-link>
      </td>
      <td>
        @if (item.gebaeudeStatus) {
          <span>
            <cap-link [params]="[item.egid]" [target]="navTargets.NAV_GWR_GEBAUEDE" [tooltipParams]="{ nummer: item.egid }">
              {{ item.gebaeudeStatus | translate }}
            </cap-link>
          </span>
        } @else {
          <span>-</span>
        }
      </td>
      <td>
        @for (g of item.grundstuecke; track g; let i = $index) {
          <span>
            @if (i < maxGrundstueckeProGebaeude && g) {
              <cap-link
                [queryParams]="getGrundstueckQueryParams(g.grundstueckNummer)"
                [target]="navTargets.NAV_GRUNDSTUECK"
                [tooltipOverride]="'DetailsZuGrundstueckAusSichtGrundbuch'">
                {{ g | kompaktGwrGrundstueck }}</cap-link
              ><br />
            }
            @if (i == maxGrundstueckeProGebaeude) {
              ...<br />
            }
          </span>
        }
      </td>
      <td>
        @for (entry of item.eingangAdresse; track entry) {
          <div>
            {{ entry | kompaktGwrGebaeudeeingangsadresse }}
          </div>
        }
      </td>
    </tr>
  }
</ng-template>
